<div class="bcg p-4 ">
    <div class="row">
      <div class="col-lg-6 col-sm-6 col-md-6">
        <p class="nav_link_cat  ms-1">
            <span class="clickable" (click)="gotoDashboard()">Dashboard</span>
            <span [style.font-weight]="'bold'"> >> </span>
            <span >Wallet</span>
            <span [style.font-weight]="'bold'"> >> </span>
            <span class="clickable" [routerLink]="['/doqfy/wallet/payment-requests']">Payment Request</span>
           
          </p>
            </div>
      <div class="col-lg-3 col-sm-3 col-md-3 "></div>
      <div class="col-lg-3 col-sm-3 col-md-3 overlay text-right">
        <app-select-branch></app-select-branch>
      </div>
     </div>
     
     <div  class="card card_outLine mt-3">
         <div class="card-body">
             <div class="row">
                 <div class="col-lg-6 col-sm-6 col-md-6">
                     <h5 class="title_five">Payment Requests</h5>
                     <p class="card-text text_p ">Amount Requested by the User</p>
                 </div>
             <div class="col-lg-6 col-sm-6 col-md-6 text-right custom_button">
                <p-button label="Export Excel" (click)="export()" icon="bx bx-export"   styleClass="p-button-sm-outline"></p-button> 
            <p-button class="ms-1" label="Back" [routerLink]="['/doqfy/admin-dashboard']"   styleClass="p-button-sm-outline"></p-button>
               
                          </div>
             </div>
                     </div>
       </div>
       <div  class="card card_outLine mt-3">
        <div class="card-body">
            <div class="row">
                <div class="col-lg-6 col-sm-6 col-md-6">
                    <h5 class="title_five">Total Deposit : {{amountbalance}}</h5>
                </div>
              
                    <div class="col-lg-2 col-sm-2 col-md-2 form_inputFields_1">
                        <app-search-input placeholder="Search here"></app-search-input>
                    </div>
                    <div class="col-lg-2 col-sm-2 col-md-2 overlay_1">
                        <app-dropdown  class="custom-dropdown text-left" [options]="states" [(ngModel)]="selectedState" (click)= getSelected() placeholder="Select State"  optionLabel="name"></app-dropdown>
        
                    </div>
                    <div class="col-lg-2 col-sm-2 col-md-2 overlay">
                            <span>
                            <p-datepicker class="custom-calendar"[(ngModel)]="selectedDate" icon="bx bxs-calendar"  placeholder="Select Month" view="month" dateFormat="MM yy"
                            [showIcon]="true" iconDisplay="input" [readonlyInput]="false" inputId="monthpicker">
                               </p-datepicker>
                              </span>
                    </div>
                    <div class="col-lg-2 col-sm-2 col-md-2 text-right">
                        <app-column-chooser [table]="dataTable"></app-column-chooser>
                    </div>


            </div>
<div class="row mt-2 mb-2">
    <app-data-table
        #dataTable
        [columnChooser]="true"
        [columns]="columns"
        [data]="payRequest"
        [totalRecords]="totalRecords"
        [rows]="1"
        [paginator]="true"
        [lazy]="true"
        [analyticsTab]="'Admin Payment Requests'"
        (pageChange)="onPageChange($event)"
        (rowClick)="viewDistribution()">
        <ng-template appTableCell="amountRequested" let-row>
            ₹ {{ row.amountRequested }}
        </ng-template>

        <ng-template appTableCell="payNow" let-row>
            <div style="height: 2rem;" appRowActionStop><p-button label="Pay Now" styleClass="p-button-sm-outline_1"></p-button></div>
        </ng-template>

        <ng-template appTableCell="distribution" let-row>
            <div class="clickable" appRowActionStop appIconAction [routerLink]="['/doqfy/wallet/distribution']">View</div>
        </ng-template>
    </app-data-table>
</div>
                   
           
            </div>
        </div>
    

</div>